import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import Home from './components/Main.vue';
import HelloWorld from './components/HelloWorld.vue';
import MessagePage from './components/MessagePage.vue';
import APIMessage from './components/api/Message.vue';


const router = new VueRouter({
  mode: 'history',  // hitory API to avoid using hash /#/...
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
        path: '/:tag',
        component: MessagePage,
        props: true,
    },
    {
      path: '/u/helloworld',
      component: HelloWorld,
    },
    {
      path: '/api/messages',
      component: APIMessage,
    }
  ],
});

export { router as default};
